/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";

import { LeaveTypesList } from "./LeaveTypesList";
import { LeaveBalances } from "./LeaveBalances";

// eslint-disable-next-line import/prefer-default-export
export function LeaveTypeSettings(): React.ReactNode {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)}>
          <Tab label="Leave Types" />
          <Tab label="Leave Balances" />
        </Tabs>
      </Box>

      <Box flex={1} overflow="hidden">
        {activeTab === 0 && <LeaveTypesList />}
        {activeTab === 1 && <LeaveBalances />}
      </Box>
    </Box>
  );
}
